import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  createRole(roleData: any) {
    return this.http.post(this.baseUrl + '/v1/cargos', roleData);
  }

  getRoles(nome: string) {
    return this.http.get(this.baseUrl + `/v1/cargos?nome=${nome}`);
  }
}
